export default "__VITE_ASSET__9a30d4c1__"